import { Box, makeStyles } from '@material-ui/core';
import { TableLoader } from '@setvi/shared/components';
import { SInfiniteTable } from '@setvi/shared/components/s-table/infinite';
import { Product, RecordType } from '@setvi/shared/interfaces';

import { useSpecificationColumns } from './useSpecificationColumns';
import { useProductSpecifications } from './useProductSpecifications';

interface ProductSpecificationsProps {
  product: Product;
  client: any;
}

const specificationTableStyles = makeStyles(theme => ({
  tableWrapper: {
    // border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2, 0)
    // borderRadius: theme.spacing(2)
  }
}));

export const ProductSpecifications = ({
  product,
  client
}: ProductSpecificationsProps) => {
  const { specificationColumns } = useSpecificationColumns();
  const classes = specificationTableStyles();
  const { specifications, isLoading } = useProductSpecifications(
    product,
    client
  );

  if (isLoading) return <TableLoader columns={specificationColumns} rows={4} />;

  return specifications?.length > 0 ? (
    <Box className={classes.tableWrapper}>
      <SInfiniteTable<RecordType>
        stripped
        header={{ columns: [] }}
        list={specifications}
        keyGetter={specification => specification.label}
        columns={specificationColumns}
        tableStyle={{
          width: '100%',
          tableLayout: 'fixed'
        }}
      />
    </Box>
  ) : (
    <>-</>
  );
};
